import { get } from 'lodash';

const styles = ({ color, fontSize, margin, typography }) => ({
  descriptionField: {
    margin: get(margin, 'm36'),
    width: '50%',
  },
  pageTitle: {
    color: get(color, 'pageTitle'),
    fontFamily: get(typography, 'pageTitle'),
    fontSize: get(fontSize, 'pageTitle'),
    marginTop: 6,
  },
});
  
export default styles;
  